import { useEffect, useState } from "react";
import useFetch from "hooks/useFetch";
import { getFetchOptions } from "utils/fetch";

// `isDeveloper` is null while the request is in flight, then true/false.
const useIsDeveloper = () => {
	const { execute } = useFetch();
	const [isDeveloper, setIsDeveloper] = useState(null);

	useEffect(() => {
		execute("/api/dev/whoami", getFetchOptions({ method: "GET" }), (data, error) => {
			if (error) {
				setIsDeveloper(false);
				return;
			}
			
			setIsDeveloper(Boolean(data?.IsDeveloper));
		});
	}, [execute]);

	return {
		isLoading: isDeveloper === null,
		isDeveloper: isDeveloper === true
	};
};

export default useIsDeveloper;
